<!--<div c-toggle="activityListVisible" c-toggle-options="{type:'fade', duration:100}">-->
<div>

    <section class="activity-list">
        <ul>
            <li ng-repeat="activity in visibleActivities">
                <a ng-click="activity.callback(activity.workflowId, activity.activityId, activity.terminatorId)">{{localize(activity.title) | uppercase}}</a>
            </li>
        </ul>
    </section>

    <section class="activity-list-menu" ng-show="activities.length > 0" ng-class="{active: activityListMenuActive}">
        <div class="title">
            <a ng-click="toggleActivityListMenu()"><i></i><i></i><i></i></a>
        </div>

        <ul class="activity-list-menu active" c-toggle="activityListMenuActive">
            <li ng-repeat="activity in activities">
                <a ng-click="activity.callback(activity.workflowId, activity.activityId, activity.terminatorId); menuHide()">{{localize(activity.title) | uppercase}}</a>
            </li>
        </ul>
    </section>

</div>
